var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeductionsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.0001C18.9852 21.0001 21 18.9853 21 16.5001C21 14.0148 18.9852 12.0001 16.5 12.0001C14.0147 12.0001 12 14.0148 12 16.5001C12 18.9853 14.0147 21.0001 16.5 21.0001Z",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7693 16.5001H18.2308",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 8.87083C14.8213 8.87083 18.2308 7.55661 18.2308 5.93545C18.2308 4.31428 14.8213 3.00006 10.6154 3.00006C6.40952 3.00006 3 4.31428 3 5.93545C3 7.55661 6.40952 8.87083 10.6154 8.87083Z",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2307 8.53875V5.93567",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.93567V15.2957C3 16.5833 5.13231 17.6633 8.10923 18.0649",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52462 13.3847C5.34 13.0801 3 12.0001 3 10.6155",
    stroke: "#0050C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeductionsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deductions-icon.fcba5331.svg";
export { ForwardRef as ReactComponent };